import APIAccessor from "services/apiProcessor";
import Constants, { MESSAGE_API_URL } from "../../constants";

class MessageService {
    protected api: APIAccessor;

    constructor() {
        this.api = new APIAccessor(MESSAGE_API_URL);
    }

    public getBySettingCode = async (settingCode: string, organizationId?: string) => {
        let query = `?settingCode=${settingCode}`;
        if (organizationId) {
            query += `&organizationId=${organizationId}`;
        };

        const result = await this.api.get({
            path: `${Constants.ApiPath.SYSTEM_SETTING.GET_BY_SETTINGCODE}${query}`,
        });
        return result.data.result;
    }

}

export default MessageService